import { render, staticRenderFns } from "./ProductCostLayout.vue?vue&type=template&id=608db1df&scoped=true"
import script from "./ProductCostLayout.vue?vue&type=script&lang=js"
export * from "./ProductCostLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "608db1df",
  null
  
)

export default component.exports